<div class="custom-toolbar">
  <button mat-icon-button *ngIf="user?.authenticated" (click)="sidenav?.toggle()" class="menu-button">
    <mat-icon>menu</mat-icon>
  </button>
  
  <span class="app-title">{{ title }}</span>
  
  <span class="spacer"></span>
  
  <button mat-icon-button *ngIf="user?.authenticated" (click)="toggleProfile()" class="profile-button">
    <mat-icon>account_circle</mat-icon>
  </button>
</div>

<mat-sidenav-container class="sidenav-container" *ngIf="user?.authenticated; else unauthContent">
  <mat-sidenav
    #sidenav
    [opened]="false"
    [mode]="'over'"
  >
    <div class="sidenav-content">
      <tt-ui-left-menu
        [user$]="user$"
        (logout)="onLogout($event)"
        (closeSideNav)="closeSideNav($event)"
      >
      </tt-ui-left-menu>
    </div>
  </mat-sidenav>
  
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #unauthContent>
  <router-outlet></router-outlet>
</ng-template>
